import { FiCheck, FiLock } from "react-icons/fi";
import useTranslator from "../../../../hooks/useTranslator";
import styles from "../authenticateYourId.module.css";

const ProcessingScreen = () => {
  const { _t } = useTranslator();

  const translate = (key: string, fallback: string) =>
    _t(key, fallback, "translation", { defaultValue: fallback });

  return (
    <div className={styles.kycProcessing} role="status" aria-live="polite">
      <span className={styles.kycProcessingSpinner} aria-hidden="true" />

      <div className={styles.kycProcessingIntro}>
        <h3>{translate("analyzingYourDocument", "Analyzing your document")}</h3>
        <p>
          {translate(
            "documentAnalysisUsuallyTakesUnderAMinute",
            "Usually takes under a minute. Don't close this window."
          )}
        </p>
      </div>

      <div className={styles.kycProcessingSteps}>
        <div className={styles.kycProcessingStep}>
          <FiCheck aria-hidden="true" />
          <span>{translate("readingTheDocument", "Reading the document")}</span>
        </div>
        <div className={styles.kycProcessingStep}>
          <FiCheck aria-hidden="true" />
          <span>
            {translate(
              "checkingThePhotoIsReadable",
              "Checking the photo is readable"
            )}
          </span>
        </div>
        <div className={styles.kycProcessingStep}>
          <span
            className={styles.kycProcessingStepSpinner}
            aria-hidden="true"
          />
          <span>
            {translate(
              "matchingTheDetailsToYourProfile",
              "Matching the details to your profile"
            )}
          </span>
        </div>
      </div>

      <div className={styles.kycProcessingEncrypted}>
        <FiLock aria-hidden="true" />
        <span>{translate("dataIsEncrypted", "Data is encrypted")}</span>
      </div>
    </div>
  );
};

export default ProcessingScreen;
